import { QueryClient } from "@tanstack/react-query";

// The auth store clears this client before another session can reuse its data.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
});
